customElements.define(
  'country-popup-modal',
  class CountryPopupModal extends HTMLElement {
    async connectedCallback() {
      const {
        flag: flags = [],
        content: [content],
        form: [form],
        close: [close],
      } = codeGetTargets(this);

      this.content = content;

      // Don't show the country popup in the theme editor. More info: https://shopify.dev/changelog/detect-the-theme-editor-using-liquid-and-javascript
      if (Shopify.designMode) return;

      const addFlagEventListeners = (flags) => {
        flags.forEach((flag) => {
          flag.addEventListener('mouseenter', () => (flag.dataset.active = ''));
          flag.addEventListener('mouseleave', () => delete flag.dataset.active);
        });
      };

      const addCloseEventListeners = (close) => {
        close.addEventListener('click', () => {
          let transitionEnd = false;
          hideCountryPopup(transitionEnd);
        });
      };

      const checkSelectedCountry = () => {
        if (localStorage.getItem('selectedCountry')) {
          hideCountryPopup();
        } else {
          showCountryPopup();
        }
      };

      const addFormClickListener = () => {
        if (form) {
          form.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.target;

            if (!isValidTarget(target)) return;

            updateFormValues(target);
            form.submit();
            saveSelectedCountry(target);
            hideCountryPopup();
          });
        } else {
          console.error('Form element not found');
        }
      };

      const showCountryPopup = () => {
        this.toggleAttribute('data-active', true);
        this.toggleAttribute('inert', false);
        trapFocus(this.content);
        publish('scrollLockToggle', true);
      };

      const hideCountryPopup = (transitionEnd = true) => {
        this.removeAttribute('data-active');
        this.setAttribute('inert', 'true');
        removeTrapFocus(this.content);


        if (transitionEnd) {
          this.content.addEventListener(
            'transitionend',
            () => {
            if (!this.hasAttribute('data-active')) publish('scrollLockToggle', false);
          },
          { once: true },
        );
        } else {
          publish('scrollLockToggle', false);
        }


      };

      const isValidTarget = (target) => {
        return target.dataset.country && target.dataset.language;
      };

      const updateFormValues = (target) => {
        this.querySelector('input[name="country_code"]').value = target.dataset.country;
        this.querySelector('input[name="language_code"]').value = target.dataset.language;
      };

      const saveSelectedCountry = (target) => {
        const country = target.dataset.country;
        const language = target.dataset.language;
        localStorage.setItem('selectedCountry', JSON.stringify({ country, language }));
      };

      const handleModalToggle = ({ id: newId, trigger: newTrigger, open }) => {
        if (this.id !== newId) return;

        if (!this.hasAttribute('data-active') && open) {
          this.trigger = newTrigger;
          showCountryPopup();
        } else if (this.hasAttribute('data-active') && !open) {
          hideCountryPopup();
        }
      };

      addFlagEventListeners(flags);
      addCloseEventListeners(close);
      checkSelectedCountry();
      addFormClickListener();
      this.unsubscribe = subscribe('modalToggle', (event) => handleModalToggle(event));
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }
  },
);
